export const resetMyContentObj = () => {
  return {
    type: 'RESET_MY_CONTENT_OBJ',
    payload: {},
  }
}
export const resetMyContentStatus = (reset) => {
  return {
    type: 'RESET_MY_CONTENT_STATUS',
    payload: reset,
  }
}

export const myContentError = (error) => {
  return {
    type: 'MY_CONTENT_ERROR',
    payload: error,
  }
}

export const getMyContent = (data) => {
  return {
    type: 'GET_MY_CONTENT',
    payload: data,
  }
}
export const setMyContent = (data) => {
  return {
    type: 'SET_MY_CONTENT',
    payload: data,
  }
}

export const updateMyContent = (data) => {
  return {
    type: 'UPDATE_MY_CONTENT',
    payload: data,
  }
}
export const updatedMyContent = (data) => {
  return {
    type: 'UPDATED_MY_CONTENT',
    payload: data,
  }
}
